import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_PAGE,
  UPDATE_PAGE,
  CREATE_PAGE,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { VoAuth } from "@vocollege/app";
import Utils from "services/Utils";

export default function PageEdit() {
  const router = useParams<any>();
  const navigate = useNavigate();
  const [urlValue, setUrlValue] = useState("");

  // Methods.

  const getInitialState = () => {
    const initialState: { [key: string]: any } = {
      id: 0,
      title: "",
      short_title: "",
      body: "",
      status: 0,
      url: "",
      author: null,
      template: "standard",
      tags: [],
      images: [],
      attachments: [],
      settings: [],
    };
    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  const handleTitleChange = (data: any) => {
    setUrlValue(data);
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/pages");
    }
  };

  const getAvailableTemplateValues = () => {
    return Object.keys(I18n.get.page.templates).map((template: string) => ({
      label: I18n.get.page.templates[template],
      value: template,
    }));
  };

  return (
    <Layout>
      <Form
        // client={client}
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
                onChange: handleTitleChange,
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "template",
                label: I18n.get.form.labels.template,
                type: "select",
                grid: {
                  xs: 12,
                  md: 3,
                },
                params: {
                  availableValues: getAvailableTemplateValues,
                },
              },
              {
                name: "images",
                label: I18n.get.misc.image,
                type: "file_field",
                grid: {
                  xs: 12,
                  md: 9,
                },
                params: {
                  filetypes: ["image"],
                  multiple: false,
                },
              },
              {
                name: "settings",
                label: I18n.get.misc.settings,
                type: "checkboxes",
                grid: {
                  xs: 12,
                },
                params: {
                  availableValues: I18n.get.page.settings,
                },
              },
              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                grid: {
                  xs: 12,
                },
              },
            ],
          },
          {
            key: "extra",
            label: I18n.get.misc.extra,
            fields: [
              {
                name: "url",
                label: I18n.get.form.labels.url,
                type: "url_field",
                required: true,
                grid: {
                  xs: 12,
                },
                validation: {
                  required: true,
                },
                overrideValue: urlValue,
                params: {
                  dependencyHelperText: I18n.trans(
                    I18n.get.form.messages.fieldPopulatedBy,
                    { field: I18n.get.form.labels.title }
                  ),
                },
              },
              {
                name: "short_title",
                label: I18n.get.form.labels.shortTitle,
                type: "text",
                grid: {
                  xs: 12,
                },
              },
              {
                name: "tags",
                label: I18n.get.tag.labels.tags,
                type: "tags_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["tag"],
                    addNew: true,
                  },
                },
              },
              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
            ],
          },
          {
            key: "attachments",
            label: I18n.get.misc.attachments,
            fields: [
              {
                name: "attachments",
                label: I18n.get.misc.attachments,
                type: "content_list",
                grid: {
                  xs: 12,
                },
                params: {
                  contentType: "file",
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.form.labels.createPage,
          created: I18n.get.page.messages.pageSaved,
          updated: I18n.get.page.messages.pageSaved,
          deleted: I18n.get.page.messages.pageDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "page",
          get: GET_PAGE,
          create: CREATE_PAGE,
          update: UPDATE_PAGE,
        }}
        // paths={{
        //   back: "/content/pages",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
